
import Vue from "vue";
import { mapFields } from "vuex-map-fields";
import { Anonym, DinMisstanke, VilkenRoll } from "@/store/types";
import ForetagSammanstallning from "@/components/Kontaktuppgifter/ForetagSammanstallning.vue";
import AnmalareSammanstallning from "@/components/Kontaktuppgifter/AnmalareSammanstallning.vue";
import PrivatpersonSammanstallning from "@/components/Kontaktuppgifter/PrivatpersonSammanstallning.vue";
export default Vue.extend({
    name: "FkKontaktuppgifterSammanfattning",
    components: {
        AnmalareSammanstallning,
        ForetagSammanstallning,
        PrivatpersonSammanstallning,
    },
    data: () => ({
        Anonym,
        DinMisstanke,
        VilkenRoll,
    }),
    computed: {
        ...mapFields(["forsteg.misstanke", "forsteg.vilkenroll", "kontaktuppgifter.villDuVaraAnonym"]),
    },
});
